import { messagesService } from "@dv5/api"
import { TextWidgetData } from "@dv5/domain"

export const useTextWidgetUpdate = (
    canvasId: string,
    widgetId: string,
    data: TextWidgetData
) => {
    const updateData = (patchedPaths: string[], newData: Partial<TextWidgetData>) => {
        const updatedData = { ...data, ...newData }
        messagesService.send("canvas.change-widget-data", {
            canvasId,
            widgetId,
            patchedPaths,
            data: updatedData as TextWidgetData,
        })
    }

    return { updateData }
}
